<template>
    <div class="blackBg  animate__animated animate__slideInLeft">
        <div class="cardTit">
            <span class="teamName">{{ teamName ? teamName : 'XXX' }}</span>
            <p class="date">
                <span class="today">{{ dateArray[(dateInd - 1) < 0 ? 0 : (dateInd - 1)] }}</span>
            </p>
        </div>
        <div class="barDate cardBg" id="cardBg" @click="clearTimeFn">
            <div v-show="playersNameList.length" class="barBox" v-for="(item, index) in GPSItem">
                <p class="barTit PingFang">{{ item ? item.displayName : '' }}</p>
                <div :key="index" class="GPS-AIM-bar-item" :id="'GPS-AIM-bar-'+index"></div>
            </div>
            <div v-show="!playersNameList.length" style="line-height: 21vw;font-size: 26px;text-align: center;">暂无数据
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "athleticPerformance",
    computed: {
        teamId() {
            return this.$store.state.teamId;
        }
    },
    data() {
        return {
            teamName: this.$store.state.teamName ? this.$store.state.teamName.split('_')[0] : '',//梯队名称
            nowWeek: '',//当前周
            playersNameList: [],//球员list
            GPSItem: [],
            time: null,//定时器
            dateInd: 0,//查看的是七天内日期的index
            dateArray: [],//近七天的日期
            beforeDestroy: false,
            height: 1
        }
    },
    mounted() {
        this.sevenDay();
        this.getFilter();
    },
    methods: {
        sevenDay() {
            //设置日期，当前日期的前七天
            let myDate = new Date(); //获取今天日期
            myDate.setDate(myDate.getDate() - 6);
            this.dateArray = [];
            let dateTemp;
            let flag = 1;
            for (let i = 0; i < 6; i++) {
                dateTemp = this.$global.formatDate(new Date(myDate.getFullYear() + '/' + (myDate.getMonth() + 1) + "/" + myDate.getDate()), 'yyyy/MM/dd', true);
                this.dateArray.unshift(dateTemp);
                myDate.setDate(myDate.getDate() + flag);
            }
            this.dateArray.unshift(this.$global.formatDate(new Date(), 'yyyy/MM/dd', new Date()));
            this.nowWeekFn();
            this.info();
        },
        info() {
            let data = {
                teamId: this.teamId,
                date: this.dateArray[this.dateInd]
            }
            if (this.dateInd == this.dateArray.length) {
                this.dateInd = 0;
            } else {
                this.dateInd++
            }
            console.log(data)
            this.gpsReportFn(data)
        },
        //  获取gps 筛选项
        getFilter() {
            let data = {
                teamId: this.teamId
            }
            this.$server.getGpsFilter(data).then(res => {
                if (res.code === 200) {
                    this.GPSItem = [];
                    if (res.data && res.data.length) {
                        let arr = [];
                        res.data.map(item => {
                            if (item.gps) {
                                // console.log(item.slug)
                                arr.push({
                                    ...item,
                                    playerNameAll: [],
                                    allData: [],
                                })
                            }

                        })
                        this.GPSItem = arr;
                    }
                }
            })
        },
        //当前周
        nowWeekFn() {
            this.$server.nowWeek()
                .then((res) => {
                    this.nowWeek = res.data;
                })
        },
        //gps --总数据
        gpsReportFn(data) {
            this.$server.gpsReport(data)
                .then((res) => {
                    this.GPSItem.forEach(item => {
                        item.playerNameAll = []
                        item.allData = []
                    })
                    let GPSData = res.data || []
                    GPSData.forEach((item) => {
                        this.playersNameList.push(item.playerName)
                        this.GPSItem.forEach(gps => {
                            const currentGps = item.data.find(dataValue => dataValue.slug === gps.slug)
                            if (currentGps && currentGps.value) {
                                gps.allData.push({
                                    value: Number(currentGps.value).toFixed(gps.decimal),
                                    timeFormat: gps.timeFormat,
                                    name: gps.displayName
                                })
                            } else {
                                gps.allData.push({
                                    value: '',
                                    timeFormat: gps.timeFormat,
                                    name: gps.displayName
                                })
                            }
                            gps.playerNameAll.push(item['playerName'])
                        })
                    })
                    setTimeout(() => {
                        this.GPSItem.forEach((item, index) => {
                            this.weekBarData(item, 'GPS-AIM-bar-' + index);
                        })
                        this.scroll();

                    }, 500)

                })
        },
        //柱状图
        weekBarData(data, id) {
            if (!data.allData.length) {
                return
            }
            let barWidth = 20;//柱状图默认宽度

            this.dateBar = data;

            if (!this.dateBar.allData.length) {
                return
            }
            // 指定图表的配置项和数据
            let myChart = this.$echarts.init(document.getElementById(id));
            var labelOption = {
                show: true,
                position: 'top',
                distance: 15,
                fontSize: 18,
                color: '#5FCA83',
                formatter: (params) => {
                    if (params.data.timeFormat) {
                        const time = Number(params.value)
                        if (Number.isNaN(time)) {
                            return ''
                        } else {
                            return this.$global.timeFormat(time)
                        }
                    } else {
                        return params.value
                    }
                }
            };

            myChart.setOption({
                grid: {
                    x: 40,
                    y: 10,
                    right: 30,
                    top: 40,
                    bottom: 120,
                    left: 60,
                    borderWidth: 1
                },
                //  ------  X轴 ------
                xAxis: {
                    show: true,  // 是否显示
                    nameGap: 15, // 坐标轴名称与轴线之间的距离
                    nameRotate: 20,  // 坐标轴名字旋转
                    axisLabel: {
                        color: 'rgba(255, 255, 255, .5)',
                        rotate: 60,
                        fontSize: 18,
                        margin: 30,     // 刻度标签与轴线之间的距离
                    },
                    axisLine: {       // 坐标轴 轴线
                        show: true,  // 是否显示
                        // ------   线 ---------
                        lineStyle: {
                            color: 'rgba(255, 255, 255, .5)',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisTick: {    // 坐标轴 刻度
                        show: false,  // 是否显示
                    },
                    data: this.playersNameList
                },
                //   ------   y轴  ----------
                yAxis: {
                    show: true,  // 是否显示
                    nameTextStyle: {    // 坐标轴名称样式
                        color: '#fff',
                        padding: [5, 0, 0, 5]  // 坐标轴名称相对位置
                    },
                    nameGap: 15, // 坐标轴名称与轴线之间的距离

                    axisLine: {    // 坐标轴 轴线
                        show: false,  // 是否显示
                        // ----- 线 -------
                        lineStyle: {
                            color: '#616162',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisTick: {      // 坐标轴的刻度
                        show: true,    // 是否显示
                        inside: true,  // 是否朝内
                        length: 3,      // 长度
                        lineStyle: {
                            color: '#616162',  // 默认取轴线的颜色
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisLabel: {      // 坐标轴的标签
                        show: true,    // 是否显示
                        inside: false,  // 是否朝内
                        rotate: 0,     // 旋转角度
                        marginRight: 5,     // 刻度标签与轴线之间的距离
                        color: 'rgba(255, 255, 255, .5)',  // 默认轴线的颜色
                        fontSize: '14'
                    },
                    splitLine: {    // gird 区域中的分割线
                        show: true,   // 是否显示
                        lineStyle: {
                            color: 'rgba(255, 255, 255, .2)',
                            width: 1,
                            type: 'dashed'
                        }
                    },
                },
                //  -------   内容数据 -------
                series: [
                    {
                        type: 'bar',      // 类型
                        label: labelOption,
                        itemStyle: {    // 图形的形状
                            normal: {
                                //柱形图圆角，初始化效果
                                barBorderRadius: [3, 3, 0, 0],
                                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: '#34C955'
                                },
                                    {
                                        offset: 1,
                                        color: '#6EFF8E'
                                    }])
                            }
                        },
                        barWidth: barWidth,  // 柱形的宽度
                        // barGap:'10%',
                        // barCategoryGap: '20%',  // 柱形的间距

                        data: this.dateBar.allData,
                    }
                ]
            }, true);

        },
        //滚动数据
        scroll() {
            var hScrollTop = document.getElementById('cardBg').scrollTop;
            var hScrollHeight = document.getElementById('cardBg').scrollHeight;
            var offsetHeight = document.getElementById('cardBg').offsetHeight;

            // console.log(hScrollTop + " " + hScrollHeight + " " + this.height + ' ' + offsetHeight);
            if ((offsetHeight + hScrollTop) >= hScrollHeight) {//滚动条已经到了容器底部
                this.height = -1;
            }else if (hScrollTop === 0) {
                this.height = 1;
            }

            var h = hScrollTop + this.height;
            document.getElementById('cardBg').scrollTop = h;
            this.time = window.requestAnimationFrame(this.scroll)
        },
        clearTimeFn() {
            console.log('执行取消事件')
            window.cancelAnimationFrame(this.time)
            return false;
        },
    },
    beforeDestroy() {
        window.cancelAnimationFrame(this.time)
    },
    deactivated() {
        window.cancelAnimationFrame(this.time)
    }
}
</script>

<style scoped lang="less">
.cardTit {
    background-image: url("../../assets/img/updateImg/head_2.png");
    position: relative;
    font-size: 30px;

    .date {
        font-family: PingFangMedium;
        color: #fff;
        display: inline-block;
        line-height: 120px;
        position: absolute;
    }

    .date {
        right: 2vw;
        display: inline-block;

        .week {
            margin-right: 2vw;
        }
    }
}

.barDate {
    padding: 2vw;
    box-sizing: border-box;
    height: calc(100% - 115px);
    overflow-y: auto;

    .barBox {
        width: 100%;
        height: 500px;
        overflow-x: auto;

        .GPS-AIM-bar-item {
            height: calc(100% - 45px);
            width: 100%;
        }
    }

    .barTit {
        color: #fff;
        font-size: 28px;
    }
}
</style>
